import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { closeDialog } from "../Dialog/actions";
import { setLanguage } from "./actions";

import { Flag, FLAG_SIZE } from "../../Components/Flag/Flag";

import flagCSS from "./dialog.module.scss";

import images from "../../assets/flags";

import { Button } from "../../Components/button";
import { translate, Langs } from "../../translations/translate";

const flags = [
  {
    lang: Langs.It,
    image: images.it,
  },
  {
    lang: Langs.Es,
    image: images.es,
  },
  {
    lang: Langs.Uk,
    image: images.uk,
  },
  {
    lang: Langs.Ro,
    image: images.ro,
  },
  {
    lang: Langs.De,
    image: images.de,
  },
  {
    lang: Langs.Fr,
    image: images.fr,
  },
];

export const LanguageSelectBody = (props) => {
  const currentLang = localStorage.getItem("lang");
  const { actions, title } = props;
  const [ selectedLanguage, setLang ] = useState(flags.findIndex(({ lang }) => lang === currentLang));
  return (
  <>
    <div className={flagCSS["title"]}> {title} </div>
    <div className={flagCSS["body"]}>
      {flags.map(({ lang, image }, i) => <Flag
        key={i}
        onClick={() => {
          localStorage.setItem("lang", lang);
          setLang(i);
        }}
        image={image}
        size={FLAG_SIZE.Small}
        isActive={i === selectedLanguage}
      />)}
    </div>
    <div className={flagCSS["footer"]}>
      <Button onClick={() => {
        actions.closeDialog();
        actions.setLanguage(flags[selectedLanguage].lang);
        }}
        label={translate("save")}
        isActive={selectedLanguage >= 0}
        />
    </div>
  </>);
};

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch) =>  ({
  actions : bindActionCreators({
    closeDialog,
    setLanguage,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelectBody);
